import FavoritesView from 'components/views/FavoritesView';
import { getRessourcesForCluster } from 'components/views/FavoritesView/ressource';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
	actionCreators as favoritesAC,
	getDynamicProductFavorites,
	getFavorites,
	getTotalFavoriteCount,
	getTotalFavoriteCountWithDynamicProducts,
} from 'store/favorites';
import { getIsAuthenticated } from 'store/login';
import { getHasUserBeenLoaded, getUserData } from 'store/profile';
import { HistoryType, MatchType } from 'types/withRouter';

export type FavoritesViewContainerPropsType = {
	history: HistoryType;
	match: MatchType & {
		params: {
			cluster?: string;
		};
	};
};

function getCluster(props): string {
	const cluster = props.match ? props.match.params.cluster || '' : '';
	return getRessourcesForCluster(cluster).id;
}

export const mapStateToProps = (state, props: FavoritesViewContainerPropsType) => ({
	isAuthenticated: getIsAuthenticated(state),
	isUserLoaded: getHasUserBeenLoaded(state),
	userData: getUserData(state),
	favorites: getFavorites(state, getCluster(props)),
	total: getTotalFavoriteCount(state),
	dynamicProducts: getDynamicProductFavorites(state),
	totalWithDynamicProducts: getTotalFavoriteCountWithDynamicProducts(state),
});

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...favoritesAC }, dispatch);
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default withRouter((connector as any)(FavoritesView));
